/*eslint no-console: 0*/

import FlowSimpleList from '../flows/FlowSimpleList.react';
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import Relay from 'react-relay';
import {FormattedMessage, injectIntl, defineMessages} from 'react-intl';
import * as FeatureFlags from '../../common/util/FeatureFlags.ts';
import * as Permission from '../../common/util/Permission';
import LoadingButton from '../fw/LoadingButton.react';
import Link from 'react-router/lib/Link';
import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import {callGrant} from './ChannelGranted.react';
import InvokeChannelJobMutation, {channelJobMutationPromise} from './InvokeChannelJobMutation.react';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import EventTracker from '../app/EventTracker';
import ScenarioBox from '../scenarios/ScenarioBox.react';
import ScenarioStrip from '../scenarios/ScenarioStrip.react';
import ChannelHeader from './ChannelHeader.react';
import {showJobNotification} from '../app/notification';
import {renderProgress} from '../jobs/JobView.react';
import RefreshButton from '../jobs/RefreshButton.react';
import {STATUS_FINISHED, STATUS_FAILED} from '../../common/model-api/JobType';
import {onClickTryAgainCachingWithNotification} from './ActivateChannelCaching.react';
import mutationError from '../channel-defs/mutationError';
import {CACHING_STATUS_NONE, CACHING_STATUS_FAILED, CACHING_STATUS_IN_PROGRESS, CACHING_STATUS_CACHED} from "../../common/model-api/ChannelType";
import ChannelViewParent from './channelViewParent.react';
import {} from "../../common/model-api/ChannelType";
import ConfirmDialog from '../fw/ConfirmDialog.react';
import config from '../../common/config';
import TransferChannelToDevelModal from './TransferChannelToDevelModal.react';
import ActivateChannelCachingMutation from './ActivateChannelCachingMutation.react';
import SetChannelConfidentialMutation from './SetChannelConfidentialMutation.react';
import {ChannelList} from './ChannelList.react';
import {AUTH_TYPE_PER_USER} from '../../common/model-api/ChannelDefType';
import OkDialog from '../fw/OkDialog.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';

import "./channel.scss";
import * as BrowserPermission from '../BrowserPermission';
import {safeJSONparse} from "../../common/util/safeJSONparse";
import moment from 'moment';
import { getUISettings } from '../app/UISettings.react';

const messages = defineMessages({
    dataFetch: {id: 'channelView.dataFetch', 'defaultMessage': "Data is being fetched."},
    cantDelete: {id: 'channelView.cantDelete', 'defaultMessage': "You have to delete {count, plural, one {the active flow} other {all active flows}} in which {count, plural, one {is} other {are}} using this application before disconnecting it."},
    lastSeen: {id: 'channelView.lastSeen', 'defaultMessage': 'last seen {relativeTime}'},
    transferToDevel: {id: 'channelView.transferToDevel', defaultMessage: 'Copy to devel'},
});

const activateCaching = defineMessages({
    title: {id: 'activateChannelCaching.title', defaultMessage: "Activate caching"},
    message: {id: 'channelCaching.explanation2', defaultMessage: "<p>For some features of {productName}, it is necessary to activate caching.</p><p> Caching stores data from {channelDefName} in {productName} and allows to handle advanced querying and searching.</p>"},
    confirm: {id: 'channel.activateCaching', defaultMessage: "Activate caching mode"},
});

const disableCaching = defineMessages({
    title: {id: 'disableChannelCaching.title', defaultMessage: "Disable caching"},
    message: {id: 'disableCaching.explanation2', defaultMessage: 'By disabling caching for "{channelDefName}", some of {productName} features may stop work.'},
});

const activateConfidentialMode = defineMessages({
    title: {id: 'channelConfidential.title', defaultMessage: "Confidential mode"},
    message: {id: 'channelConfidential.explanation', defaultMessage: "<p>If you are worried about your data, you can activate confidential mode. No data will be stored in {productName} and your data will not even be logged. And we will delete all cached data including API requests.</p>"},
    confirm: {id: 'channel.enableConfidential', defaultMessage: "Activate confidential mode"},
});

const disableConfidentialMode = defineMessages({
    message: {id: 'channelConfidential.disable.explanation', defaultMessage: "By disabling confidential mode, we will start to log API request for your review and the data caching will be possible for another {productName} features."},
    confirm: {id: 'channel.disableConfidential', defaultMessage: "Disable confidential mode"},
});

export class ChannelView extends ChannelViewParent {

    constructor(props) {
        super(props);

        this.state = {
            linkStatus: null,
            showTransferModal: false,
        };
    }

    onClickFetcher(jobName) {
        const data = this.props.user.organisation.channel;

        EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
            event: 'channel-fetcher',
            type: 'application'
        });

        return channelJobMutationPromise({channel: data, jobName: jobName})
                .then((response) => {
                    showJobNotification(this.props.intl, response.invokeChannelJob.job, this.props.intl.formatMessage(messages.dataFetch));
                }).catch((transaction) => {
                    mutationError(transaction);
                });
    }

    checkLinkStatus() {
        fetch(config.LINK_SERVER + '/@/status/' + encodeURIComponent(this.props.user.organisation.channel.agentLink) + '/', {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
            }
        }).then((response) => {
            return response.json();
        }).then((json) => {
            console.log("Agent check response", json);
            this.setState({linkStatus: json});
        }).catch((e) => {
            this.setState({linkStatus: {
                'status': 'error',
            }});

            console.error(e);
        });
    }

    componentWillUnmount() {
        if (this.linkInterval) {
            clearInterval(this.linkInterval);
            this.linkInterval = null;
        }
    }

    componentDidMount() {
        if (this.props.user.organisation.channel.agentLink) {
            this.checkLinkStatus();
            this.linkInterval = setInterval(() => this.checkLinkStatus(), 10000); /* check every 10 seconds */
        }
    }

    onClickSetting() {
        const data = this.props.user.organisation.channel;

        let type = types[this.typeName];

        let path = urlMapping.getUrl(type, "options", data);
        this.context.router.push(path);
    }

    onClickGrant() {
        const channel = this.props.user.organisation.channel;
        let channelDefMetadata = safeJSONparse(channel.channelDef.metadata);

        return callGrant(channel, null, channelDefMetadata.grantType, this.props.relay);
    }

    toggleCaching(caching, resolve, reject) {
        const data = this.props.user.organisation.channel;

        let onFailure = (transaction) => {
            mutationError(transaction);
            reject();
        };

        let onSuccess = (response) => {
            resolve();
        };

        Relay.Store.commitUpdate(new ActivateChannelCachingMutation({channel: data, cache: caching}), {
            onFailure,
            onSuccess
        });
    }

    onClickActiveCaching() {
        return ConfirmDialog(this.props.intl, {
            title: this.props.intl.formatMessage(activateCaching.title),
            message: this.props.intl.formatMessage(activateCaching.message, {productName: config.PRODUCT_NAME, channelDefName: this.props.user.organisation.channel.channelDef.name}),
            confirm: '<i class="fa fa-fw fa-play"></i> ' + this.props.intl.formatMessage(activateCaching.confirm)
        }).then(() => {
            return new Promise((resolve, reject) => {
                EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
                    event: 'channel-activate-caching',
                    type: 'application'
                });

                this.toggleCaching(true, resolve, reject);
            });

        }).catch(() => {});
    }

    onClickDisableCaching() {
        // urlMapping.getUrl(type, "caching", data)
        return ConfirmDialog(this.props.intl, {
            title: this.props.intl.formatMessage(disableCaching.title),
            message: this.props.intl.formatMessage(disableCaching.message, {productName: config.PRODUCT_NAME, channelDefName: this.props.user.organisation.channel.channelDef.name}),
            confirm: '<i class="fa fa-fw fa-stop-circle"></i> ' + this.props.intl.formatMessage(disableCaching.title),
        }).then(() => {
            return new Promise((resolve, reject) => {
                EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
                    event: 'channel-disable-caching',
                    type: 'application'
                });

                this.toggleCaching(false, resolve, reject);
            });

        }).catch(() => {});
    }

    toggleConfidentialMode(confidential, resolve, reject) {
        const data = this.props.user.organisation.channel;

        let onFailure = (transaction) => {
            mutationError(transaction);
            reject();
        };

        let onSuccess = (response) => {
            resolve();
        };

        Relay.Store.commitUpdate(new SetChannelConfidentialMutation({channel: data, confidential: confidential}), {
            onFailure,
            onSuccess
        });
    }

    onClickActivateConfidentialMode() {
        // urlMapping.getUrl(type, "caching", data)
        return ConfirmDialog(this.props.intl, {
            title: this.props.intl.formatMessage(activateConfidentialMode.title),
            message: this.props.intl.formatMessage(activateConfidentialMode.message, {productName: config.PRODUCT_NAME}),
            confirm: '<i class="fa fa-fw fa-user-secret"></i> ' + this.props.intl.formatMessage(activateConfidentialMode.confirm)
        }).then(() => {
            return new Promise((resolve, reject) => {
                EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
                    event: 'channel-activate-confidential-mode',
                    type: 'application'
                });

                this.toggleConfidentialMode(true, resolve, reject);
            });

        }).catch(() => {});
    }

    onClickDisableConfidentialMode() {
        // urlMapping.getUrl(type, "caching", data)
        return ConfirmDialog(this.props.intl, {
            title: this.props.intl.formatMessage(activateConfidentialMode.title),
            message: this.props.intl.formatMessage(disableConfidentialMode.message, {productName: config.PRODUCT_NAME}),
            confirm: '<i class="fa fa-fw fa-ban"></i> ' + this.props.intl.formatMessage(disableConfidentialMode.confirm)
        }).then(() => {
            return new Promise((resolve, reject) => {
                EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
                    event: 'channel-disable-confidential-mode',
                    type: 'application'
                });

                this.toggleConfidentialMode(false, resolve, reject);
            });

        }).catch(() => {});
    }

    onClickTransferToDevel = () => {
        this.setState({ showTransferModal: true });
    };

    closeTransferModal = () => {
        this.setState({ showTransferModal: false });
    };

    getSecondaryActions(data) {
        let actions = [];
        let metadata = safeJSONparse(data.metadata);

        // Copy to devel button (only for developers on production/stage)
        if (BrowserPermission.hasPermission(Permission.PERM_DEVELOPER) && BrowserPermission.developerModeEnabled() && (config.STAGE === 'prod' || config.STAGE === 'stage')) {
            actions.push(
                <button
                    className="btn btn-default"
                    key="transfer-to-devel"
                    onClick={this.onClickTransferToDevel}
                >
                    <i className="fa fa-fw fa-share"></i> <FormattedMessage {...messages.transferToDevel} />
                </button>
            );
        }

        if (metadata.canLoadData && BrowserPermission.hasPermission(Permission.PERM_DEVELOPER) && BrowserPermission.developerModeEnabled()) {
            actions.push(<LoadingButton className="btn btn-default" href="#" key="2" onClick={() => { return this.onClickFetcher('fetcher'); }}><i className="fa fa-fw fa-play"></i> <FormattedMessage defaultMessage="Refresh data" id="channel.refreshData" /></LoadingButton>);
        }
        // if (metadata.canLoadData && BrowserPermission.hasPermission(Permission.PERM_DEVELOPER) && BrowserPermission.developerModeEnabled()) {
        //     actions.push(<LoadingButton className="btn btn-default" href="#" key="3" onClick={() => { return this.onClickFetcher('transformer'); }}><i className="fa fa-fw fa-play"></i> <FormattedMessage defaultMessage="Transform data" id="channel.transformData" /></LoadingButton>);
        // }

        if (data.channelDef.usageDataSource && FeatureFlags.hasFeatureFlag(FeatureFlags.FEATURE_CAN_USE_RELATIONS, this.props.user) && !data.channelDef.virtual) {
            actions.push(<Link className="btn btn-default" key="10" to={urlMapping.getUrl(types['relationDefs'], "list", this.props.user.organisation)} type="button"><i className="fa fa-fw fa-link"></i> <FormattedMessage defaultMessage="My Relation definition" id="relationDefs.list" /></Link>);
        }
        if (FeatureFlags.hasFeatureFlag(FeatureFlags.FEATURE_ADDONS, this.props.user) && !data.channelDef.virtual) {
            actions.push(<Link className="btn btn-default" key="12" to={urlMapping.getUrl(types['channelAddons'], "list", this.props.user.organisation.channel)} type="button"><i className="fa fa-fw fa-plug"></i>  <FormattedMessage defaultMessage="Addons" id="channelAddonDefs.list" /></Link>);
        }

        if (data.cachingStatus === CACHING_STATUS_CACHED && BrowserPermission.hasPermission(Permission.PERM_DEVELOPER) && BrowserPermission.developerModeEnabled()) {
            actions.push(<Link className="btn btn-default" key="13" to={urlMapping.getUrl(types['dataSets'], "list", this.props.user.organisation.channel)} type="button"><i className="fa fa-fw fa-database"></i> <FormattedMessage defaultMessage="Cached data" id="channelView.cachedData" /></Link>);
        }

        if (this.props.user.organisation.channel.screens.edges.length > 0) {
            actions.push(<Link className="btn btn-default" key="11" to={urlMapping.getUrl(types['screens'], "list", this.props.user.organisation.channel)} type="button"><i className="fa fa-fw fa-desktop"></i> <FormattedMessage defaultMessage="Defined screens" id="screens.list" /></Link>);
        }
        if (BrowserPermission.hasPermission(Permission.PERM_DEVELOPER) && metadata.canStoreData && BrowserPermission.developerModeEnabled()) {
            actions.push(<Link className="btn btn-default" key="9" to={urlMapping.getUrl(types['events'], "list", data)} type="button"><FormattedMessage defaultMessage="Channel events" id="events.list" /></Link>);
        }
        if (metadata.canAccessData && !data.confidential && !data.channelDef.virtual) {
            actions.push(<Link className="btn btn-default" key="6" to={urlMapping.getUrl(types['fetches'], "list", data)}><i className="fa fa-fw fa-history"></i> <FormattedMessage defaultMessage="API Requests" id="fetches.list" /></Link>);
        }
        if (metadata.canAccessData && !data.confidential && !data.channelDef.virtual) {
            actions.push(<Link className="btn btn-default" key="6" to={urlMapping.getUrl(types['fetches'], "list", data)}><i className="fa fa-fw fa-history"></i> <FormattedMessage defaultMessage="API Requests" id="fetches.list" /></Link>);
        }
        if (metadata.canAccessData && !data.confidential && !data.channelDef.virtual) {
            actions.push(<Link className="btn btn-default" key="7" to={urlMapping.getUrl(types['channelErrors'], "list-fail", data)}><i className="fa fa-fw fa-history"></i> <FormattedMessage defaultMessage="Errors" id="channelErrors.list" /></Link>);
        }
        if (BrowserPermission.hasPermission(Permission.PERM_INSTANCE_DEVELOPER) && BrowserPermission.developerModeEnabled()) {
            actions.push(<Link className="btn btn-default" key="8" to={urlMapping.getUrl(types['organisationEvents'], 'list-channel', {id: data.realId, organisation_id: data.organisation_id})}><i className="fa fa-fw fa-history"></i> <FormattedMessage defaultMessage="Application Events" id="organisationApplicationEvents.list" /></Link>);
        }

        if (BrowserPermission.hasPermission(Permission.PERM_DEVELOPER) && BrowserPermission.developerModeEnabled()) {
            actions.push(<Link className={"btn btn-default"} key='logger' to={urlMapping.getUrl(types['channels'], 'logger', data)}><i className="fa fa-fw fa-history"></i> <FormattedMessage defaultMessage="Logs" id="logger.list" /></Link>);
        }

        return actions;
    }

    getCachingAction(data) {
        switch (data.cachingStatus) {
            case CACHING_STATUS_CACHED:
                return (
                    <small className="detail">
                        <i className="fa fa-cloud-download"></i>{" "}
                        <FormattedMessage defaultMessage="Caching enabled." id="channel.cachingEnabled2" />{" "}
                        {
                            data.lastCachingRefresh
                                ? <span><FormattedMessage defaultMessage="Last sync: {relativeTime}." id="channel.lastRefresh" values={{relativeTime: this.props.intl.formatRelative(new Date(data.lastCachingRefresh))}} /></span>
                                : null
                        }
                    </small>
                );
            case CACHING_STATUS_IN_PROGRESS:
                return (
                    <div className="channel-in-progress layout-row">
                        <div className="flex-none">
                            <small className="detail">
                                <i className="fa fa-cloud-download"></i> <FormattedMessage defaultMessage="Caching in progress" id="channel.cachingInProgress" />{data.cachingInProgressJob ? ": " : ". "}
                            </small>
                        </div>
                        { data.cachingInProgressJob
                            ? <div className="flex-none"><small>{renderProgress(types['jobs'], data.cachingInProgressJob, this.props.intl.formatMessage)}</small></div>
                            : null
                        }
                        {data.cachingInProgressJob && data.cachingInProgressJob.status !== STATUS_FINISHED && data.cachingInProgressJob.status !== STATUS_FAILED
                            ? <div className="flex-none"><RefreshButton autoRefresh className="btn-sm" fastRefresh relay={this.props.relay} /></div>
                            : null
                        }
                        <div className="flex" />
                    </div>
                );
            case CACHING_STATUS_FAILED:
                return (
                    <div>
                        <small className="detail"><i className="fa fa-cloud-download"></i> <FormattedMessage defaultMessage="Caching enabled but failed." id="channel.cachingFailed" /></small>{" "}
                        <LoadingButton className="btn btn-default" href="#" key="2" onClick={() => { return onClickTryAgainCachingWithNotification(this.props.user.organisation.channel, this.props.intl); }}>
                            <i className="fa fa-fw fa-play"></i> <FormattedMessage defaultMessage="Try again" id="channel.tryRefreshAgain" />
                        </LoadingButton>
                    </div>
                );
        }
    }

    getActions(data) {
        let hasEditRights = BrowserPermission.hasOrganisationPermission(Permission.PERM_EDIT_CHANNEL, this.props.user.organisation.realId);
        if (!hasEditRights && data.channelDef.authType !== AUTH_TYPE_PER_USER) {
            return [];
        }

        let metadata = safeJSONparse(data.metadata);
        let type = types[this.typeName];
        let actions = [];

        // Helper function to check if button should be hidden
        const shouldHideButton = () => {
            if (!getUISettings().isUpgatesAddon && !getUISettings().isEshopRychleAddon) return false;

            // If we have channelDef in URL parameter
            if (getUISettings().channelDefId) {
                return getUISettings().channelDefId === data.channelDef.realId;
            }

            return true; // If channelDef is not defined, hide for all
        };

        let notice = global.location.hash === '#authError' || data.invalid;

        // Connection Options button
        if (hasEditRights && !shouldHideButton()) {
            actions.push(<Link className={"btn btn-default" + (notice ? ' notice' : '')} key="1" to={urlMapping.getUrl(type, "options", data)}>
                <i className="fa fa-fw fa-cog"></i> 
                <FormattedMessage defaultMessage="Connection Options" id="channel.connectionOptions" />
            </Link>);
        }

        // Grant Access button
        if (metadata.hasGrant && !shouldHideButton()) {
            //let notice = location.hash === '#authError' || data.invalid;
            actions.push(<LoadingButton className={"btn btn-default" + (notice ? ' notice' : '')} href="#" key="4" onClick={() => { return this.onClickGrant(); }}><i className="fa fa-fw fa-check-circle-o"></i> <FormattedMessage defaultMessage="Grant access" id="channel.grantAccess" /></LoadingButton>);
        }

        // if (hasEditRights && FeatureFlags.hasFeatureFlag(FeatureFlags.FEATURE_ENABLE_CACHING, this.props.user) && channelDefMetadata.canStoreData && !data.confidential && !channelDefMetadata.requiresCaching) {
        // 	if (!data.cachingStatus || data.cachingStatus === CACHING_STATUS_NONE) {
        // 		actions.push(<Link className="btn btn-default" key="5" onClick={() => this.onClickActiveCaching()}><i className="fa fa-fw fa-play"></i> <FormattedMessage defaultMessage="Enable caching" id="channel.enableCaching" /></Link>);
        // 	}
        // 	else if (data.cachingStatus === CACHING_STATUS_CACHED || data.cachingStatus === CACHING_STATUS_IN_PROGRESS) {
        // 		actions.push(<Link className="btn btn-default" key="5" onClick={() => this.onClickDisableCaching()}><i className="fa fa-fw fa-stop-circle"></i> <FormattedMessage defaultMessage="Disable caching" id="channel.disableCaching" /></Link>);
        // 	}
        // }

        if (hasEditRights && metadata.canConfidential && !shouldHideButton()) {
            if (data.confidential) {
                actions.push(<Link className="btn btn-default" key="6" onClick={() => this.onClickDisableConfidentialMode()}><i className="fa fa-ban fa-fw"></i> <FormattedMessage defaultMessage="Disable confidential mode" id="channel.disableConfidential" /></Link>);
            } else {
                actions.push(<Link className="btn btn-default" key="6" onClick={() => this.onClickActivateConfidentialMode()}><i className="fa fa-fw fa-user-secret"></i> <FormattedMessage defaultMessage="Activate confidential mode" id="channel.enableConfidential" /></Link>);
            }
        }

        // Delete button
        if (!getUISettings().hideDeleteButton && !shouldHideButton()) {
            actions.push(this.getDeleteButton({
                data: data,
                type: type,
                beforeDelete: () => {
                    let flowCount = this.getFlowCount();
                    if (flowCount > 0) {
                        return OkDialog(this.props.intl, {
                            message: this.props.intl.formatMessage(messages.cantDelete, {count: flowCount}),
                        }).then(() => {
                            return false;
                        }).catch((e) => {
                            return false;
                        });
                    }
                    return true;
                }
            }));
        }

        return actions;
    }

    renderContent() {
        return null;
    }

    filterFlows = (flow) => {
        const channel = this.props.user.organisation.channel;

        let selectedChannels = safeJSONparse(flow.selectedChannels);
        for (let key of Object.values(selectedChannels)) {
            if (key === channel.realId) {
                return true;
            }
        }
        return false;
    };

    renderAuthExpiresIn() {
        if (this.props.user.organisation.channel.authExpiresIn) {
            let authExpiresIn = this.props.user.organisation.channel.authExpiresIn;

            if (moment().isAfter(moment(authExpiresIn))) {
                return (
                    <small><span className="fa fa-circle" style={{color: 'red'}} /> <FormattedMessage defaultMessage="Authorization data expired: {authExpiresIn}" id="channel.authExpired" values={{authExpiresIn: this.props.intl.formatRelative(authExpiresIn)}} /></small>
                );
            } else if (moment().add(7, 'days').isAfter(moment(authExpiresIn))) {
                return (
                    <small><span className="fa fa-circle" style={{color: 'orange'}} /> <FormattedMessage defaultMessage="Authorization wil expire at: {authExpiresIn}" id="channel.authExpired7days" values={{authExpiresIn: this.props.intl.formatRelative(authExpiresIn)}} /></small>
                );

            } else {
                return (
                    <small><span className="fa fa-circle" style={{color: 'green'}} /> <FormattedMessage defaultMessage="Authorization data will expire: {authExpiresIn}" id="channel.authExpiredOk" values={{authExpiresIn: this.props.intl.formatRelative(authExpiresIn)}} /></small>
                );
            }

        }

        return null;
    }

    renderLinkStatus() {
        if (this.state.linkStatus) {
            let title = (this.state.linkStatus.hostname || '') + ' ' + (this.state.linkStatus.ip || '') + (this.state.linkStatus.version ? " (" + this.state.linkStatus.version + ")" : "");
            if (this.state.linkStatus && this.state.linkStatus.status === 'online') {
                return (
                    <small title={title}><span className="fa fa-circle" style={{color: 'green'}} /> <FormattedMessage defaultMessage="Link online" id="channel.linkStatusOnline" /></small>
                );
            } else if (this.state.linkStatus && this.state.linkStatus.status === 'paused') {
                    return (
                        <small title={title}><span className="fa fa-circle" style={{color: 'orange'}} /> <FormattedMessage defaultMessage="Link paused" id="channel.linkStatusPaused" /></small>
                    );
            } else {
                title = this.props.intl.formatMessage(messages.lastSeen, {relativeTime: this.props.intl.formatRelative(this.state.linkStatus.lastDisconnection)});
                return (
                    <small title={title}><span className="fa fa-circle" style={{color: 'red'}} /> <FormattedMessage defaultMessage="Link offline" id="channel.linkStatusOffline" /></small>
                );
            }
        }

        return null;
    }

    getFlowCount() {
        if (this.props.user.organisation.flows && this.props.user.organisation.flows.edges && this.props.user.organisation.flows.edges.length) {
            let flows = this.props.user.organisation.flows.edges.filter(({node}) => this.filterFlows(node) && node.deleted === false);

            return flows.length;
        }

        return 0;
    }

    render() {
        const data = this.props.user.organisation.channel;

        let hasCustomName = false;
        let title = data.channelDef.name;
        if (data.name) {
            hasCustomName = true;
            title += ' - ' + data.name;
        }

        let options = data.options ? safeJSONparse(data.options) : {};

        return (
            <AppPanel breadcrumbParams={this.getBreadcrum()} className="ChannelView" title={title}>
                <h3><FormattedMessage defaultMessage="Connected application" id="application.connectedApplicationTitle" /></h3>
                <ChannelHeader actions={this.getActions(data)} actions2={this.getSecondaryActions(data)} data={data} hasCustomName={hasCustomName} organisation={this.props.user.organisation} title={title}>
                    {data.channelDef.description ? <p>{data.channelDef.description}</p> : null}
                    {data.deleted ? <div style={{"color": "red", marginBottom: '.5em'}}><small><span className="fa-stack fa-lg"><i className="fa fa-circle fa-stack-2x"></i><i className="fa fa-times fa-stack-1x fa-inverse"></i></span> <FormattedMessage defaultMessage="App has been deleted" id="channel.deletedChannel" /></small></div> : null}
                    {options.emailAddress && ChannelList.hasAuthOptions(data) ? <small className="detail"><i className="fa fa-envelope-o"></i>&nbsp;<FormattedMessage defaultMessage="Email account:" id="channel.emailAccount" />&nbsp;<strong>{options.emailAddress}</strong></small> : null}
                    {data.confidential ? <small className="detail"><i className="fa fa-user-secret"></i> <FormattedMessage defaultMessage="confidential mode enabled" id="channel.confidentialEnabled" /></small> : null}
                    {this.getCachingAction(data)}
                    {data.invalid && !data.deleted ? <div style={{"color": "red", marginBottom: '.5em'}}><small><span className="fa-stack fa-lg"><i className="fa fa-circle fa-stack-2x"></i><i className="fa fa-exclamation fa-stack-1x fa-inverse"></i></span> <FormattedMessage defaultMessage="Connection has invalid authentication information." id="channel.invalidChannel" /></small></div> : null}
                    {this.state.linkStatus && !data.deleted ? this.renderLinkStatus() : null}
                    {this.renderAuthExpiresIn()}
                </ChannelHeader>

                {/* TODO get used scenarios for this channel (! not the channel defintion)
                <ScenarioStrip
                    scenarios={data.usedInScenarios}
                    title={(<FormattedMessage defaultMessage="Used in scenarios:" id="channelList.scenarios.related" />)}
                    viewAll={(
                        <Link className="right btn btn-default btn-lg" to={urlMapping.getUrl(types['channelDefs'], "public-apps", data.channelDef)}><FormattedMessage defaultMessage="Show more scenarios" id="channelList.scenarios.seeMore" />{" "}<i className="fa fa-chevron-circle-right"></i></Link>
                    )}
                />*/}

                {this.renderContent()}

                {!getUISettings().hideRelatedFlows && (
                    <FlowSimpleList
                        filter={this.filterFlows}
                        organisation={this.props.user.organisation}
                    />
                )}

                {!getUISettings().hideScenarios && (
                    <ScenarioStrip
                        scenarios={data.relevantScenarios}
                        title={(<FormattedMessage defaultMessage="Related scenarios:" id="channelList.scenarios.related" />)}
                        viewMore={(
                            <Link className="right btn btn-default btn-lg" to={urlMapping.getUrl(types['channelDefs'], "public-apps", data.channelDef)}>
                                <FormattedMessage defaultMessage="Show all scenarios" id="channelList.scenarios.seeAll" />{" "}
                                <i className="fa fa-chevron-circle-right"></i>
                            </Link>
                        )}
                    />
                )}

                {this.state.showTransferModal && (
                    <TransferChannelToDevelModal
                        channel={data}
                        onClose={this.closeTransferModal}
                        show={this.state.showTransferModal}
                    />
                )}
            </AppPanel>
        );
    }
}

export function wrapGenericChannel(channelView) {
    return Relay.createContainer(wrapNotFound(injectIntl(channelView), (props) => {
        return props.user.organisation && props.user.organisation.channel;
    }), {
        initialVariables: {
            organisationId: '',
            channelId: '',
        },
        prepareVariables (variables) {
            if (!variables.organisationId) {
                variables.organisationId = getLastOrganisationId();
            }

            return variables;
        },
        fragments: {
            user: () => Relay.QL`
                fragment on User {
                    featureFlags,
                    organisation(id: $organisationId) {
                        id,
                        realId,
                        name,
                        featureFlags,
                        flows(first: 200, after: null, deleted: false) {
                            edges {
                                node {
                                    id,
                                    realId,
                                    selectedChannels,
                                    deleted
                                }
                            }
                        },
                        ${FlowSimpleList.getFragment('organisation')},
                        channel(id: $channelId) {
                            id,
                            realId,
                            deleted,
                            organisation_id,
                            instance_id,
                            type,
                            cachingStatus,
                            cachingInProgressJob {
                                id,
                                progress,
                                status
                            },
                            confidential,
                            description,
                            name,
                            invalid,
                            failedAuthAttempts,
                            authExpiresIn,
                            lastCachingRefresh,
                            metadata,
                            options,
                            authOptions,
                            userOptions,
                            currentUserOptions,
                            agentLink,
                            channelDef {
                                id,
                                name,
                                extendedFrom_id,
                                extendedFrom {
                                    id,
                                    realId,
                                    icon
                                },
                                authType,
                                description,
                                icon,
                                virtual,
                                metadata,
                                urlFragment,
                                usageDataSource,
                                realId
                            },
                            ${InvokeChannelJobMutation.getFragment('channel')},
                            ${TransferChannelToDevelModal.getFragment('channel')},
                            screens(first: 1) {
                                edges {
                                    node {
                                        id
                                    }
                                }
                            },
                            relevantScenarios(first: 10) {
                                edges {
                                    node {
                                        id,
                                        realId,
                                        ${ScenarioBox.getFragment('scenario')}
                                    }
                                },
                                pageInfo {
                                    hasNextPage,
                                    hasPreviousPage,
                                    startCursor,
                                    endCursor
                                }
                            }
                        }
                    }
                }
            `,
        },
    });
}

export default wrapGenericChannel(ChannelView);
